"use client"

import * as React from "react"
import { QualityHealthHero } from "./quality/quality-health-hero"
import { QualityNeedsAttention } from "./quality/quality-needs-attention"
import { QualityLearnerVoice } from "./quality/quality-learner-voice"
import { QualityExperienceTrend } from "./quality/quality-experience-trend"
import { QualityProgramComparison } from "./quality/quality-program-comparison"
import { QualityClinicalBlock } from "./quality/quality-clinical-block"
import {
  QualityEvaluationLoadBlock,
  QualityParticipationBlock,
} from "./quality/quality-participation-load"
import {
  QualityAccreditationBlock,
  QualityClosingLoop,
} from "./quality/quality-closing-accreditation"

export function EvaluationDashboardQualityView() {
  return (
    <div className="flex flex-col gap-10">
      <QualityHealthHero />

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <QualityNeedsAttention />
        <QualityLearnerVoice />
      </div>

      <QualityExperienceTrend />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <QualityProgramComparison />
        <QualityClinicalBlock />
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <QualityParticipationBlock />
        <QualityEvaluationLoadBlock />
      </div>

      <QualityClosingLoop />
      <QualityAccreditationBlock />
    </div>
  )
}
